import type { Rating } from "./types";

export interface Tier {
  value: Rating;
  label: string;
  shortLabel: string;
  detail: string;
}

export const TIERS: Tier[] = [
  { value: 4, label: "Absolutely", shortLabel: "Absolutely", detail: "Move me in" },
  { value: 3, label: "Yes", shortLabel: "Yes", detail: "I’d live here" },
  { value: 2, label: "Maybe", shortLabel: "Maybe", detail: "Could be" },
  { value: 1, label: "Probably not", shortLabel: "Probably not", detail: "Unlikely" },
  { value: 0, label: "Never", shortLabel: "Never", detail: "Not for me" },
];

export const TIER_BY_VALUE = Object.fromEntries(TIERS.map((tier) => [tier.value, tier])) as Record<Rating, Tier>;
